module.exports = __webpack_public_path__ + "static/media/ru.d75bd454.svg";